
;
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uxfjium08hr"]=  window.__ectimmers["ecom-uxfjium08hr"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-uxfjium08hr';
                    document.querySelectorAll('.ecom-uxfjium08hr').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5e06h7efg86"]=  window.__ectimmers["ecom-5e06h7efg86"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-5e06h7efg86';
                    document.querySelectorAll('.ecom-5e06h7efg86').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-acvf5ncuqip"]=  window.__ectimmers["ecom-acvf5ncuqip"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-acvf5ncuqip';
                    document.querySelectorAll('.ecom-acvf5ncuqip').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uq9jloao2l8"]=  window.__ectimmers["ecom-uq9jloao2l8"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-uq9jloao2l8';
                    document.querySelectorAll('.ecom-uq9jloao2l8').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xa4xt1po1h"]=  window.__ectimmers["ecom-xa4xt1po1h"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-xa4xt1po1h';
                    document.querySelectorAll('.ecom-xa4xt1po1h').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-a6fzb4xnfo"]=  window.__ectimmers["ecom-a6fzb4xnfo"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-a6fzb4xnfo';
                    document.querySelectorAll('.ecom-a6fzb4xnfo').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-w084bthije9"]=  window.__ectimmers["ecom-w084bthije9"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-w084bthije9';
                    document.querySelectorAll('.ecom-w084bthije9').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wf7ovkxchq"]=  window.__ectimmers["ecom-wf7ovkxchq"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-wf7ovkxchq';
                    document.querySelectorAll('.ecom-wf7ovkxchq').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zhbivvdt909"]=  window.__ectimmers["ecom-zhbivvdt909"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-zhbivvdt909';
                    document.querySelectorAll('.ecom-zhbivvdt909').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vpg7a1867s9"]=  window.__ectimmers["ecom-vpg7a1867s9"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-vpg7a1867s9';
                    document.querySelectorAll('.ecom-vpg7a1867s9').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-cawwh7emlmh"]=  window.__ectimmers["ecom-cawwh7emlmh"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-cawwh7emlmh';
                    document.querySelectorAll('.ecom-cawwh7emlmh').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9x8f60c6a3w"]=  window.__ectimmers["ecom-9x8f60c6a3w"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-9x8f60c6a3w';
                    document.querySelectorAll('.ecom-9x8f60c6a3w').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9wdq78m6ys"]=  window.__ectimmers["ecom-9wdq78m6ys"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-9wdq78m6ys';
                    document.querySelectorAll('.ecom-9wdq78m6ys').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-62nkev13jzv"]=  window.__ectimmers["ecom-62nkev13jzv"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-62nkev13jzv';
                    document.querySelectorAll('.ecom-62nkev13jzv').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-61ibpmqjs0u"]=  window.__ectimmers["ecom-61ibpmqjs0u"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-61ibpmqjs0u';
                    document.querySelectorAll('.ecom-61ibpmqjs0u').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-w7kdotjr2k"]=  window.__ectimmers["ecom-w7kdotjr2k"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-w7kdotjr2k';
                    document.querySelectorAll('.ecom-w7kdotjr2k').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ka0zhrzyvyb"]=  window.__ectimmers["ecom-ka0zhrzyvyb"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-ka0zhrzyvyb';
                    document.querySelectorAll('.ecom-ka0zhrzyvyb').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4ifkoqod78l"]=  window.__ectimmers["ecom-4ifkoqod78l"] || {};
if(!this.$el)return!1;const e=this.$el,t=function(i){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let a=parseInt(i.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-4ifkoqod78l"]["jbutw47l9"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},a)};this.settings.animation&&t(this)
                    
                    });
                    const settings = {"animation":false};
                    const ID = 'ecom-4ifkoqod78l';
                    document.querySelectorAll('.ecom-4ifkoqod78l').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-122o2d6csfq"]=  window.__ectimmers["ecom-122o2d6csfq"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-122o2d6csfq';
                    document.querySelectorAll('.ecom-122o2d6csfq').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3w7mvxh4wai"]=  window.__ectimmers["ecom-3w7mvxh4wai"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"none","lightbox":"no"};
                    const ID = 'ecom-3w7mvxh4wai';
                    document.querySelectorAll('.ecom-3w7mvxh4wai').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pyvvmvcw56h"]=  window.__ectimmers["ecom-pyvvmvcw56h"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"lightbox","lightbox":"no"};
                    const ID = 'ecom-pyvvmvcw56h';
                    document.querySelectorAll('.ecom-pyvvmvcw56h').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pqxpmv86fro"]=  window.__ectimmers["ecom-pqxpmv86fro"] || {};
const e=this.$el;if(!!e&&this.isLive&&(window.location.pathname.includes("challenge")&&this.settings.scroll_in_view&&setTimeout(function(){var t=document.querySelector(".shopify-challenge__container");t.scrollIntoView()},100),location.search==="?contact%5Btags%5D=newsletter&form_type=customer")){const t=e.querySelector("form");t&&t.querySelector(".ecom-shopify__newsletter-form-message.ecom-dn")&&t.querySelector(".ecom-shopify__newsletter-form-message.ecom-dn").classList.remove("ecom-dn")}
                    
                    });
                    const settings = {"scroll_in_view":true};
                    const ID = 'ecom-pqxpmv86fro';
                    document.querySelectorAll('.ecom-pqxpmv86fro').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            